import { SchemaTypeRef } from './schema.js';
import { ExpressionConstraint } from './constraint.js';
import { v1 as uuid } from 'uuid';
import { Product, ProductGroup } from './product.js';
import { Option, OptionGroup } from './option.js';

export interface Record {
  readonly _id: string | undefined;  // unique id in db
  kind: RecordKind;
}

export abstract class DataRecord implements Record {
  public type: SchemaTypeRef; // foreign key to type
  readonly _id: string | undefined;
  kind: RecordKind;
  public availability: ExpressionConstraint[] = [];

  constructor(_class: SchemaTypeRef, kind: RecordKind, id?: string) {
    this.kind = kind;
    this.type = _class;
    this._id = id || uuid();
  }
}

export enum RecordKind {
  Schema             = 'Schema',
  Product            = 'Product',
  ProductGroup       = 'ProductGroup',
  Option             = 'Option',
  OptionGroup        = 'OptionGroup',
  OclConstraint      = 'OclConstraint',
  ExternalField      = 'ExternalField',
  CompatibilityTable = 'CompatibilityTable',
  OclFilter          = 'OclFilter',
  JsFilter           = 'JsFilter'
}

export function productTypeGuard(record: Record): record is Product {
  return record.kind === RecordKind.Product;
}

export function productGroupTypeGuard(record: Record): record is ProductGroup {
  return record.kind === RecordKind.ProductGroup;
}

export function optionTypeGuard(record: Record): record is Option {
  return record.kind === RecordKind.Option;
}

export function optionGroupTypeGuard(record: Record): record is OptionGroup {
  return record.kind === RecordKind.OptionGroup;
}
